import { ReactElement } from 'react';
import { Field } from 'formik';

import { Label } from '../Label/Label';
import { ToggleInput } from '../ToggleInput/ToggleInput';
import { SmileyInput } from '../SmileyInput/SmileyInput';
import { validateField } from '../../utils/validations';
import { getDataTest } from '../../utils/dataTests';

// ### Component reduces complexity of adding new radio (toggle) field to Formik

export interface ToggleFieldProps {
    name: string;
    id: string;
    variant: string;
    value: string;
    label?: string;
    smileys?: boolean;
    className?: string;
    optional?: boolean;
    error?: boolean;
    valueLabel?: string;
}

export const ToggleField = ({
    name,
    id,
    variant,
    value,
    label,
    smileys,
    className,
    optional,
    error,
    valueLabel,
    ...props
}: ToggleFieldProps): ReactElement => {
    return (
        <div className={className} {...props}>
            {label && (
                <Label htmlFor={name} data-test={getDataTest(props, 'Label')}>
                    {label}
                </Label>
            )}
            <Field
                name={name}
                id={id}
                value={value}
                type={variant}
                label={valueLabel}
                component={smileys ? SmileyInput : ToggleInput}
                validate={(value: string | number) => validateField(value, optional)}
                error={error}
                data-test={getDataTest(props, 'Input')}
            />
        </div>
    );
};
